import MetricBase from "models/metrics/MetricBase";
import ConversionGroup from "models/groups/ConversionGroup";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";

class MetricBookingcountBing extends MetricBase {
    constructor() {
        super({
            field: "metric_booking_count",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.bing-hotel-ads.bookingcount.chartName"),
            serieLabel: i18n.t("metrics.bing-hotel-ads.bookingcount.serieLabel"),
            tooltip: i18n.t("metrics.bing-hotel-ads.bookingcount.tooltip"),
            group: new ConversionGroup(),
        });
    }
}

export default MetricBookingcountBing;
